import { connect, mapProps } from '@formily/react';
import { CnInputTextArea as UiInputTextArea, } from '@/components/cn-input-textarea';
import { mapSize, mapStatus } from '@/form/__builtins__';
export var CnInputTextArea = connect(UiInputTextArea, mapProps(mapSize, mapStatus));
CnInputTextArea.displayName = 'CnInputTextArea';
